import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'machine-menu',
  templateUrl: './machine-menu.component.html',
  styleUrls: ['./machine-menu.component.scss']
})
export class MachineMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
